export { default } from './ErrorPage';
export * from './ErrorPage';
